import { render, staticRenderFns } from "./wishDetail.vue?vue&type=template&id=50f5b50e&scoped=true"
import script from "./wishDetail.vue?vue&type=script&lang=js"
export * from "./wishDetail.vue?vue&type=script&lang=js"
import style0 from "./wishDetail.vue?vue&type=style&index=0&id=50f5b50e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f5b50e",
  null
  
)

export default component.exports